import dealer from './dealer';
class sdAnalytics{
     sd;
     events = [];
     config = {
    //     'brand': "LEXUS",
    // 'providerID': "TagRail",
    // 'retailerID': "3105",
     }
     data;

    async sdAnalyticsInitialize(apiConfigurations){
     if(apiConfigurations.sdConfiguration){
        this.data = {
            chatProfitCenter: 'sales',
            chatType: 'chat',
            chatSessionId: dealer.getChatSessionId(),
            chatProvider: apiConfigurations.sdConfiguration.chatProvider,
        }
        // const active = this.isActive(apiConfigurations.sdConfiguration);
        // if (active){}
        this.isActive(apiConfigurations.sdConfiguration);
        // console.log(document,'ss')
        const s = document.createElement('script');
        const config = this.config;
        const link = config.scriptUrl || "https://lexus-tagging-prod.azureedge.net/scripts/sd.js";
        // if(window.location.href.startsWith("https")) link = "https://lexus-tagging-staging.azureedge.net/scripts/sd.js"
        s.text = `
        (function (i, s, o, g, r, a, m) {
        i['ShiftAnalyticsObject'] = r; i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments)
        }, i[r].l = 1 * new Date(); a = s.createElement(o),
        m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g;
        m.parentNode.insertBefore(a, m)
        })(window, document, 'script', '${link}', 'sd');
        sd('create', '${config.brand}', '${config.retailerID}', '${config.providerID}');`;
        document.body.appendChild(s);
        await this.make();
        }
     }
    isActive(shiftConfig) {
        // this._active = false;
        if (shiftConfig) {
            this.config = shiftConfig;
        }
        
        // return this._active;
    }
    make() {
        this.sd = window.sd;
        // console.log("window-sd", this.sd);
        // console.log("window", document.body);
    }
    _isEventLogged(e) {
        return this.events.indexOf(e) > -1;
    }

     _active = dealer.getChatClientSettings() ? dealer.getChatClientSettings().sdConfiguration : false ;
     
   getData(){
       return {
        chatProfitCenter: 'sales',
        chatType: 'chat',
        chatSessionId: dealer.getChatSessionId(),
        chatProvider:  dealer.getChatClientSettings().sdConfiguration ? dealer.getChatClientSettings().sdConfiguration.chatProvider : '',
        }
    }
    
    

    chatImpression() {
        if (this._active) {
            if (this._isEventLogged('chatImpression')) return;
            window.sd('dataLayer', {
                digRet: this.getData(),
                events: 'chatImpression',
            });
            window.sd('send');
            this.events.push('chatImpression');
        }
    }
    chatClick() {
        if (this._active) {
            window.sd('dataLayer', {
                digRet: this.getData(),
                events: 'chatClick',
            });
            window.sd('send');
        }
    }
    chatUserMessage(chatMessages) {
        if (this._active) {
            chatMessages.forEach(message => {
                window.sd('dataLayer', {
                    digRet: this.getData(),
                    chatMessageType: 'agent',
                    chatMessageContent: message.body,
                    events: 'chatUserMessage',
                });
                window.sd('send');
            });
        }
    }
    chatLead() {
        if (this._active) {
            window.sd('dataLayer', {
                digRet: this.getData(),
                chatLeadId: dealer.getChatSessionId(),
                events: 'chatLead',
            });
            window.sd('send');
        }
    }
    chatClosed() {
        if (this._active) {
            window.sd('dataLayer', {
                digRet: this.getData(),
                events: 'chatClosed',
            });
            window.sd('send');
        }
    }
}
export default sdAnalytics;